export default "__VITE_ASSET__CSScz7kx__"